import $ from 'jquery';

import DDTemplates from './DDTemplates';
import Menu from './Menu';
import Drupal from './Drupal';
import Header from './Header';
import Sticky from './Sticky';
import Gallery from './Gallery';
import Toolbar from './Toolbar';
import MobileMenu from './MobileMenu';
import SmartFooter from './SmartFooter';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
import FooterMods from './FooterMods';
import PodMods from './PodMods';
import Placeholder from './Placeholder';
import ProgramsRedirect from './ProgramsRedirect';
import Redirect from './Redirect';
import AccordionWrap from './AccordionWrap';
import AccordionFix from './AccordionFix';
import AccordionContainer from './AccordionContainer';
import Banner from './Banner';
import BackgroundImage from './BackgroundImage';
import RemoveLink from './RemoveLink';
import Hero from './Hero';
import StringSplit from './StringSplit';
import SelectList from './SelectList';
import Columns from './Columns';
import SliderPrograms from './Slider.Programs';
import SingleChild from './SingleChild';
import SliderEvents from './Slider.Events';
import SliderFeatured from './Slider.Featured';
import HomepageEvents from './HomepageEvents';
import HomeSignUp from './HomeSignUp';
import SelectBox from './SelectBox';
import BrowserCheck from './BrowserCheck';
import ActivityView from './ActivityView';
import ActivityTypeFadeText from './ActivityType.FadeText';
import TitleCaption from './TitleCaption';

// Google Maps Integration Locator Map View.
import LocatorMap from './LocatorMap';
import GeofieldFormController from './GeofieldFormController';

// Google DFP Ads
import GooglePublisherTags from './GooglePublisherTags';
import GoogleNativeAd from './GoogleNativeAd';

// Community Calendar
import CommunityCalendar from './CommunityCalendar';

// Add the theme behaviors
Drupal.behavior((context) => {
  // Helpers
  const $body = $(document.body, context);

  // DD Template Behaviors
  if (!document.body.DDTemplates) {
    document.body.DDTemplates = new DDTemplates(context);
  }

  // Google DFP
  if (!document.body.GooglePublisherTags) {
    document.body.GooglePublisherTags = new GooglePublisherTags();
  }

  // Google DFP Ad Unit
  $('.native-ad', context).each((i, element) => {
    if (!element.GoogleNativeAd) {
      element.GoogleNativeAd = new GoogleNativeAd(element);
    }
  });

  // Get browser and version
  $body.each((i, element) => {
    if (!element.browserCheck) {
      element.browserCheck = new BrowserCheck(element);
    }
  });

  // Fix our damn menus from displaying orphaned children
  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Sticky sidebars
  $('.page-sidebar', context).each((i, element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main/Primary Site Navigation
  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.Menu && !element.MobileMenu) {
      element.Menu = new Menu(element);
      element.MobileMenu = new MobileMenu(element);
    }
  });

  // Controls the states of the menu and search states
  $('.toolbar', context).each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Controls the page overlay display
  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js
  $('.headroom', context).each((i, element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Adds .has-banner class to body if banner exists
  $('.page-top .block', context).each((i, element) => {
    if (!element.banner) {
      element.banner = new Banner(element);
    }
  });

  // Background image
  $('.banner, .activity-type .node-teaser', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element);
    }
  });

  $('.home-programs .views-row', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element, {
        destSelector: '.node-image',
      });
    }
  });

  $('.home-community .views-row', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element, {
        destSelector: '.node-inner',
      });
    }
  });

  // Smart Footer
  $('.page-footer', context).each((i, element) => {
    const $footprint = $('.footprint', context);
    if (!element.SmartFooter && $footprint.length) {
      element.SmartFooter = new SmartFooter(element, $footprint);
      element.FooterMods = new FooterMods(element);
    }
  });

  // Term Navigation
  $('.term-nav', context).each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Photo Galleries
  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.Gallery) {
      element.Gallery = new Gallery(element);
    }
  });

  // Wraps each accordion element
  $('.accordion-heading', context).each((i, element) => {
    if (!element.accordionWrap) {
      element.accordionWrap = new AccordionWrap(element);
      element.accordionWrap = new AccordionFix(element);
    }
  });

  // Wraps each accordion in a container
  $('.node-content', context).each((i, element) => {
    if (!element.accordionContainer) {
      setTimeout(() => {
        element.accordionContainer = new AccordionContainer(element);
      }, 300);
    }
  });

  // Calendar of Events View
  $('.calendar-feed', context).each((i, element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element);
    }
  });

  // Modify Pods for design
  $('.pods .views-row', context).each((i, element) => {
    if (!element.podMods) {
      element.podMods = new PodMods(element);
      element.redirect = new Redirect(element, {
        selector: '.node-upper-image',
      });
    }
  });

  // Set placeholder of textfield using label
  $('.pods .type-textfield, .home-sign-up .type-textfield', context).each((i, element) => {
    if (!element.placeholder) {
      element.placeholder = new Placeholder(element, {
        trim: true,
      });
    }
  });

  // Disable link in header
  $('.hero .views-row, .home-programs-headerband .views-row, .home-community .views-row, .home-events-headerband .views-row, .home-sign-up .views-row, .activities-by-community .views-row, .activity-guides .views-row, .footer-contact .views-row', context).each((i, element) => {
    if (!element.removeLink) {
      element.removeLink = new RemoveLink(element);
    }
  });

  // Make entire element clickable
  $('.activity-type .views-row', context).each((i, element) => {
    if (!element.redirect) {
      element.redirect = new Redirect(element);
    }
  });

  // Make entire element clickable
  $('.home-programs .views-row, .home-events .views-row', context).each((i, element) => {
    if (!element.programsRedirect) {
      element.programsRedirect = new ProgramsRedirect(element);
    }
  });

  // Hero background images and slider
  $('.hero', context).each((i, element) => {
    if (!element.hero) {
      element.hero = new Hero(element);
      element.hero = new StringSplit(element);
    }
  });

  // Select list generators
  let selectIdentifier = 1;
  $('.hero-links', context).each((i, element) => {
    if (!element.select) {
      element.select = new SelectList(element, {
        placeholder: 'Quicklinks',
        destination: '.block-inner',
        optionSrc: '.views-row',
        target: '.node-header a',
        numerator: selectIdentifier,
        after: true,
      });
    }
  });
  $('.activities-by-community', context).each((i, element) => {
    if (!element.commSelect) {
      element.commSelect = new SelectList(element, {
        destination: '.node-inner',
        optionSrc: '.link:not(.link-read-more)',
        target: 'a',
        placeholder: 'Pick a Location',
        numerator: selectIdentifier,
        after: true,
      });
      selectIdentifier += 1;
      element.select = new SelectBox(element, {
        placeholder: 'Pick a Location',
      });
      $(element).addClass('ready');
    }
  });
  $('.activities-by-interest', context).each((i, element) => {
    if (!element.intSelect) {
      element.intSelect = new SelectList(element, {
        placeholder: 'Pick an Interest',
        destination: '.block-inner',
        optionSrc: '.views-row',
        target: '.node-header a',
        numerator: selectIdentifier,
        after: true,
      });
      $(element).closest('.content-after').addClass('ready');
    }
  });

  // Home Programs columns / slider
  $('.home-programs .view-content', context).each((i, element) => {
    if (!element.programs) {
      element.programs = new Columns(element, {
        interval: 4,
        item: '.views-row',
        parent: '.view-content',
        divider: 'new-col',
        blockName: 'home-programs',
      });
      element.programs = new SingleChild(element);
      element.programs = new SliderPrograms(element);
      $(element).closest('.content-before').addClass('ready');
    }
  });

  // Home Events slider
  $('.home-events .view-content', context).each((i, element) => {
    if (!element.events) {
      element.events = new SliderEvents(element);
      $(element).closest('.content-after').addClass('ready');
    }
  });

  // Home Featured slider
  $('.home-featured .view-content', context).each((i, element) => {
    if (!element.featured) {
      element.featured = new SliderFeatured(element);
    }
  });

  // Homepage DD Facebook Events Feed
  $('.front .dd-facebook-events-feed--homepage', context).each((i, element) => {
    if (!element.HomepageEvents) {
      element.HomepageEvents = new HomepageEvents(element);
    }
  });

  // Home email sign-up
  $('.home-sign-up', context).each((i, element) => {
    if (!element.signUp) {
      element.signUp = new StringSplit(element);
      element.signUp = new HomeSignUp(element);
    }
  });

  // Home community
  $('.home-community', context).each((i, element) => {
    if (!element.community) {
      element.community = new StringSplit(element, {
        title: '.block-title .block-title-text',
        separator: '|',
      });
    }
  });

  // Activity Guides header split
  $('.activity-guides', context).each((i, element) => {
    if (!element.agSplit) {
      element.agSplit = new StringSplit(element);
    }
  });

  // Creates image caption using node header
  $('.activity-type .views-row', context).each((i, element) => {
    if (!element.titleCaption) {
      element.titleCaption = new TitleCaption(element);
    }
  });

  // Toggle view mode for Activity Type template
  $('.activity-type', context).each((i, element) => {
    if (!element.activityView) {
      element.activityView = new ActivityView(element);
    }
  });

  // Fade out text that exceeds parent height
  $('.activity-type .views-row', context).each((i, element) => {
    if (!element.fadeText) {
      element.fadeText = new ActivityTypeFadeText(element);
    }
  });

  $body.addClass('instant');
  setTimeout(() => {
    $body.addClass('delayed');
  }, 500);

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }

  // -----------------------------------------------------------------------------
  // Locate Your District: Map
  // -----------------------------------------------------------------------------

  $('.district-locator', context).each((i, element) => {
    if (!element.LocatorMap) {
      element.LocatorMap = new LocatorMap(element);
    }
  });

  // -----------------------------------------------------------------------------
  // Locate Your District: Form Controller
  // -----------------------------------------------------------------------------

  $('.district-locator form#district-locator-geofield', context).each((i, element) => {
    if (!element.GeofieldFormController) {
      element.GeofieldFormController = new GeofieldFormController(element);
    }
  });

  // -----------------------------------------------------------------------------
  // Community Calendar - Loads events from the activity API, creates and displays
  // a calendar with the results.
  // -----------------------------------------------------------------------------

  $('.community-calendar', context).each((i, element) => {
    if (!element.CommunityCalendar) {
      element.CommunityCalendar = new CommunityCalendar(element);
    }
  });
});
